

const log  = require('lib/log')('alerts');
const swal = require('sweetalert2');
const noop = () => {};

const btnSuccessColor = '#41c43a';
const btnErrorColor = '#ed6060';

function parseErrorMessage(err) {
    if (err.message && typeof err.message === 'object' && err.message.message) {
        return err.message.message;
    }

    if (err.response && err.response.error) {
        return err.response.error.message || JSON.stringify(err.response.error);
    }

    if (err.response && err.response.data.error) {
        return err.response.data.error.message || JSON.stringify(err.response.data.error);
    }

    if (typeof err.message === 'string') {
        return err.message;
    }

    return 'An unknown error occurred';
}

module.exports = {
    btnSuccessColor: btnSuccessColor,
    btnErrorColor: btnErrorColor,
    show: function(type, options) {
        let r;

        if (typeof this[type] !== 'function') {
            log.error(`Don't know how to show ${type}`);
            return;
        }

        options = this[type](options);

        if (typeof options.text === 'object' && options.type === 'error') {
            options.text = parseErrorMessage(options.text);
        } else if (typeof options.text !== 'string' && options.text) {
            options.text = JSON.stringify(options.text);
        }

        if (options.loader === true) {
            options = _.extend(options, {showLoaderOnConfirm: true});
        }

        r = swal(_.omit(options, ['callback', 'loader']));

        const originalCallback = options.callback;
        options.callback = function() {
            if (typeof originalCallback === 'function') {
                return originalCallback.apply(this, arguments);
            }
        };

        const showCustomerSupportDialog = function() {
        };

        return r.then(
            () => {
                showCustomerSupportDialog();
                options.callback(true);
            },
            dismiss => {
                options.callback(false, dismiss === 'cancel');
                return Promise.reject(dismiss);
            }
        );
    },

    close: (options) => swal.close(options),

    info: options => _.defaults(options || {}, {
        type:               'info',
        customClass:        'sweet-alert-success',
        confirmButtonColor: btnSuccessColor,
        confirmButtonText:  'OK',
        closeOnConfirm:     true,
        callback:           noop,
        reverseButtons:     true
    }),

    success: options => _.defaults(options || {}, {
        title:              'Success!',
        text:               '',
        type:               'success',
        customClass:        'sweet-alert-success',
        confirmButtonColor: btnSuccessColor,
        confirmButtonText:  'OK',
        closeOnConfirm:     true,
        callback:           noop,
        reverseButtons:     true
    }),

    warning: options => _.defaults(options || {}, {
        title:              'Warning',
        text:               '',
        type:               'warning',
        customClass:        'sweet-alert-success',
        confirmButtonColor: btnSuccessColor,
        allowEscapeKey:     true,
        confirmButtonText:  'OK',
        closeOnConfirm:     true,
        callback:           noop,
        reverseButtons:     true
    }),

    error: options => _.defaults(options || {}, {
        title:              'Error',
        text:               'An unknown error ocurred',
        type:               'error',
        customClass:        'sweet-alert-error',
        confirmButtonColor: btnErrorColor,
        allowEscapeKey:     false,
        confirmButtonText:  'OK',
        callback:           noop,
        reverseButtons:     true
    }),

    confirm: options => _.defaults(options || {}, {
        title:              'Are you sure?',
        text:               '',
        type:               'warning',
        customClass:        'sweet-alert-error',
        confirmButtonColor: btnSuccessColor,
        confirmButtonText:  'Yes, I\'m sure',
        showCancelButton:   true,
        allowEscapeKey:     false,
        cancelButtonText:  'No',
        callback:           noop,
        reverseButtons:     true
    }),

    criticalError: function(err) {
        return this.error({
            text:              err,
            confirmButtonText: 'Reload',
            callback:          window.location.reload.bind(window.location)
        });
    },

    dangerConfirm: function(options) {
        return this.confirm(options);
    },

    infoConfirm: function(options) {
        return this.confirm(_.extend(options, {
            type:        'info',
            customClass: 'sweet-alert-success'
        }));
    },

    warningConfirm: function(options) {
        return this.confirm(_.extend(options, {
            customClass: 'sweet-alert-success'
        }));
    },

    successConfirm: function(options) {
        return this.confirm(_.extend(options, {
            type:        'success',
            customClass: 'sweet-alert-success'
        }));
    }
};



// WEBPACK FOOTER //
// ./lib/js/alerts.js